import { IUnit } from 'app/api/unit/model/unit-management'
import { IWorkInfo } from 'app/model/user.model'
import { ParamsList, ResponseType } from 'parkway-web-common'

export interface IParamsGetApproveDayOff extends Omit<ParamsList, 'status'> {
  startDate?: string
  endDate?: string
  status?: StatusDayOffEnum[]
}

export enum StatusDayOffEnum {
  CREATED = 1,
  APPROVED = 5,
  REJECTED = 6,
  WAITING_CANCEL = 7,
  WAITING_BOM_APPROVE = 8,
  WAITING_FOR_BOM_APPROVE_CANCEL = 9,
  WAITING_FOR_BOM_APPROVE_REJECT = 10,
}

export const DefineStatusDayOffEnum = {
  [StatusDayOffEnum.CREATED]: {
    text: 'Chờ duyệt',
  },
  [StatusDayOffEnum.WAITING_CANCEL]: {
    text: 'Chờ duyệt',
  },
  [StatusDayOffEnum.WAITING_BOM_APPROVE]: {
    text: 'Chờ duyệt',
  },
  [StatusDayOffEnum.WAITING_FOR_BOM_APPROVE_CANCEL]: {
    text: 'Chờ duyệt',
  },
  [StatusDayOffEnum.WAITING_FOR_BOM_APPROVE_REJECT]: {
    text: 'Chờ duyệt',
  },
  [StatusDayOffEnum.APPROVED]: {
    text: 'Đã duyệt',
  },
  [StatusDayOffEnum.REJECTED]: {
    text: 'Từ chối',
  },
}

export enum LeaveShiftDayOffEnum {
  E = 'E',
  L = 'L',
  F = 'F',
}

export interface IUnWorkingDays {
  _id?: string
  profileId?: string
  unWorkingDayAmount?: number
  unWorkingDateStart?: string
  unWorkingDateEnd?: string
  status?: StatusDayOffEnum
  approverId?: string
  followerIds?: string[]
  applyReason?: string
  rejectReason?: string
  cancelReason?: string
  unWorkingDayType?: string
  unWorkingShift?: LeaveShiftDayOffEnum
  dayLeavePolicyId?: string
  documents?: string[]
  isApproverManualSelected?: boolean
  isCarryOver?: boolean
  linkedId?: string
  referenceIds?: string[]
  isPaid?: boolean
  createdBy?: string
}

export interface IRecordDayOff {
  _id?: string
  name?: string
  employeeOldId?: string
  mobile?: string
  email?: string
  employeeid?: string
  unWorkingDays?: IUnWorkingDays[]
  previousUnWorkingDays?: IUnWorkingDays[]

  status?: number
  createddate?: string
  createdAt?: string
  updatedAt?: string
  accountid?: string
  firstname?: string
  lastname?: string
  workinfos?: (IWorkInfo & { unit: IUnit })[]
}

export type ResponseApproveDayOff = ResponseType<IRecordDayOff[]>

export enum UnWorkingDayTypeEnum {
  DO = 'DO',
  UL = 'UL',
  AL = 'AL',
  SL = 'SL',
  HL = 'HL',
  PL = 'PL',
  ALC = 'ALc',
}

export interface IDataGetTotalDashboardDayOff {
  _id?: number
  data?: {
    unWorkingDayType?: UnWorkingDayTypeEnum
    total?: number
  }[]
}
